import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const GalleryHeader = ({ gallery }) => {
  const formatDate = (dateString) => {
    return new Date(dateString)?.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  return (
    <div className="relative rounded-2xl overflow-hidden bg-card border border-border">
      <div className="absolute inset-0">
        <Image
          src={gallery?.coverImage}
          alt={gallery?.coverImageAlt}
          className="w-full h-full object-cover opacity-20" />

        <div className="absolute inset-0 bg-gradient-to-t from-card via-card/80 to-transparent" />
      </div>
      <div className="relative p-6 md:p-8 lg:p-12">
        <div className="flex flex-col lg:flex-row gap-6 lg:gap-8">
          









          <div className="flex-1 min-w-0">
            <div className="flex flex-wrap items-start justify-between gap-4 mb-4">
              <div className="flex-1 min-w-0">
                <h1 className="text-2xl md:text-3xl lg:text-4xl font-bold mb-2">
                  {gallery?.title}
                </h1>
                <p className="text-sm md:text-base text-muted-foreground mb-4">
                  {gallery?.description}
                </p>
              </div>
            </div>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 md:w-12 md:h-12 rounded-lg bg-primary/10 flex items-center justify-center">
                  <Icon name="Images" size={20} color="var(--color-primary)" />
                </div>
                <div>
                  <p className="text-lg md:text-xl font-semibold data-text">
                    {gallery?.totalMedia}
                  </p>
                  <p className="text-xs md:text-sm text-muted-foreground">
                    Total Files
                  </p>
                </div>
              </div>

              <div className="flex items-center gap-3">
                <div className="w-10 h-10 md:w-12 md:h-12 rounded-lg bg-primary/10 flex items-center justify-center">
                  <Icon name="Image" size={20} color="var(--color-primary)" />
                </div>
                <div>
                  <p className="text-lg md:text-xl font-semibold data-text">
                    {gallery?.photoCount}
                  </p>
                  <p className="text-xs md:text-sm text-muted-foreground">
                    Photos
                  </p>
                </div>
              </div>

              <div className="flex items-center gap-3">
                <div className="w-10 h-10 md:w-12 md:h-12 rounded-lg bg-primary/10 flex items-center justify-center">
                  <Icon name="Video" size={20} color="var(--color-primary)" />
                </div>
                <div>
                  <p className="text-lg md:text-xl font-semibold data-text">
                    {gallery?.videoCount}
                  </p>
                  <p className="text-xs md:text-sm text-muted-foreground">
                    Videos
                  </p>
                </div>
              </div>

              <div className="flex items-center gap-3">
                <div className="w-10 h-10 md:w-12 md:h-12 rounded-lg bg-primary/10 flex items-center justify-center">
                  <Icon name="Calendar" size={20} color="var(--color-primary)" />
                </div>
                <div>
                  <p className="text-sm md:text-base font-medium">
                    {formatDate(gallery?.createdDate)}
                  </p>
                  <p className="text-xs md:text-sm text-muted-foreground">
                    Created
                  </p>
                </div>
              </div>
            </div>

            <div className="mt-6 flex flex-wrap items-center gap-4">
              {gallery?.downloadEnabled &&
              <div className="flex items-center gap-2 px-3 py-2 rounded-lg bg-success/10 border border-success/20">
                  <Icon name="Download" size={16} color="var(--color-success)" />
                  <span className="text-xs md:text-sm font-medium text-success">
                    Downloads Enabled
                  </span>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    </div>);

};

export default GalleryHeader;